import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import { trakrefBlue } from '../../color_utils';

const LoadingButton = ({
    text,
    loadingWheelSize,
    buttonColor,
}) => (
    <Button
        disabled
        sx={{
            backgroundColor: buttonColor
        }}
        startIcon={
            <CircularProgress size={loadingWheelSize} sx={{ color: trakrefBlue }} />
        }
        variant="contained"
    >
        {text}
    </Button>
);

LoadingButton.propTypes = {
    text: PropTypes.string,
    loadingWheelSize: PropTypes.number,
    buttonColor: PropTypes.string,
};

LoadingButton.defaultProps = {
    text: "Saving",
    loadingWheelSize: 30,
    buttonColor: "primary",
};

export default LoadingButton;
